import { Collapse, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { IDrawerItemProps } from '../../types/drawer';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { IMenuItem } from '../../types/menu';

export const DrawerItem = ({ item }: IDrawerItemProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  // Open the submenu automatically if a subitem is active
  useEffect(() => {
    if (item.children?.some((sub) => sub.route === location.pathname)) {
      setOpen(true);
    }
  }, [location.pathname, item.children]);

  const handleClickMain = () => {
    if (item.children?.length) {
      setOpen(!open);
    } else {
      navigate(item.route);
    }
  };

  const handleClickSub = (subItem: IMenuItem) => {
    navigate(subItem.route);
  };

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path);
  };

  return (
    <>
      {/* Main Item */}
      <ListItem disablePadding>
        <ListItemButton
          onClick={handleClickMain}
          selected={isActive(item.route) || item.children?.some((sub) => isActive(sub.route))}
          sx={{
            textTransform: 'capitalize',
            '&.Mui-selected': {
              backgroundColor: '#3CDAA0',
            },

            '&.Mui-selected:hover': {
              backgroundColor: '#3CDAA0',
            },
          }}
        >
          <ListItemText
            primary={item.title}
            slotProps={{
              primary: {
                margin: 0,
                fontSize: 14,
              },
            }}
          />
          {item.children?.length ? open ? <ExpandLess /> : <ExpandMore /> : null}
        </ListItemButton>
      </ListItem>

      {/* Submenu */}
      {item.children?.length && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {item.children.map((sub) => (
              <ListItem key={sub.title} disablePadding>
                <ListItemButton
                  onClick={() => handleClickSub(sub)}
                  selected={isActive(sub.route)}
                  sx={{
                    pl: 4,
                    '&.Mui-selected': { fontWeight: 600 },
                  }}
                >
                  <ListItemText
                    primary={sub.title}
                    slotProps={{
                      primary: {
                        margin: 0,
                        fontSize: 12,
                      },
                    }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Collapse>
      )}
    </>
  );
};
